import { getSession } from '../utils/utils'

export default {
    SET_SESSIONS(state, data) {
        if (data == null) {
            state.sessions = []
            return
        }

        if (Array.isArray(data)) {
            state.sessions = data.map(getSession)
            return
        }

        if (typeof data !== 'object') {
            console.warn(
                '[sessions] Неизвестный формат payload, данные не обновлены:',
                data
            )
            return
        }

        const hasTopSessions = 'sessions' in data
        const hasNestedSessions =
            typeof data.data === 'object' && 'sessions' in data.data

        if (!hasTopSessions && !hasNestedSessions) {
            console.warn(
                '[sessions] Неизвестный формат payload, данные не обновлены:',
                data
            )
            return
        }

        const sessions = hasTopSessions ? data.sessions : data.data.sessions
        state.sessions = (Array.isArray(sessions) ? sessions : []).map(getSession)
    },
}
